angular.module('createReferrals')
    .controller('CreateGuestReferralsController', ['$scope', '$state', '$stateParams', '$http', '$q', '$window', 'API_ENDPOINT', 'Notification', 'Auth', 'Procedure', 'Referral', 'UnsavedChanges', 'Logger', 'ReferralHelper', 'ReferralAutosave', 'User', 'USER_ROLES', 'Practice', '$uibModal', 'ModalHandler', 'Patient', 'BadEmailNotice',
        function ($scope, $state, $stateParams, $http, $q, $window, API_ENDPOINT, Notification, Auth, Procedure, Referral, UnsavedChanges, Logger, ReferralHelper, ReferralAutosave, User, USER_ROLES, Practice, $uibModal, ModalHandler, Patient, BadEmailNotice) {

            // user is not authenticated when using this page, otherwise it would be a normal create_referral page.
            var auth = $scope.auth = Auth.get() || {};
            $scope.current_user = Auth.current_user;

            $scope.immediateUpdate = false;
            $scope.datepickerStatus = {opened: false};
            $scope.guest = {};
            $scope.patient = {};
            $scope.attachments = []; // uploads are immediate (DCL-369); completed ones land here
            $scope.autosaveState = 'idle';

            $scope.model = {referral: {notes_attributes: [], notes: []}, practice: {}};

            var guestToken = null;

            // Reload persistence (DCL-440): a guest has no session, so the draft id
            // and its edit token live in sessionStorage keyed by the practice's
            // public id. `restoredReferral` holds the re-hydrated draft (when any) so
            // the practice auto-pick below doesn't clobber restored destination/provider.
            var draftKey = 'dcl.guestDraft.' + ($stateParams.pid || '');
            var restoredReferral = null;

            // The guest's own email rides along: guest_draft doesn't return it
            // (DCL-642), and the required email input would come back empty.
            function persistGuestDraft(id) {
                $window.sessionStorage.setItem(draftKey, angular.toJson({id: id, token: guestToken, email: $scope.guest.email}));
            }
            function forgetGuestDraft() {
                $window.sessionStorage.removeItem(draftKey);
            }

            ReferralHelper.watchProviders($scope);

            $scope.onPracticeSelected = function (selectedItem) {
                // Selecting a practice other than the restored draft's destination is
                // a deliberate override — drop the restore guard so the provider and
                // address resets below apply normally again.
                if (restoredReferral && selectedItem.id !== restoredReferral.dest_practice_id) {
                    restoredReferral = null;
                }
                // this triggers refresh of items in provider dropdown
                $scope.destinationPractice = selectedItem;

                $scope.practiceSearchText = $scope.destinationPractice.name;

                // When restoring a reloaded draft (DCL-440), keep the persisted
                // destination/provider/address instead of re-deriving them here; the
                // guard is read live so it works regardless of which async settles first.
                if(!restoredReferral && $scope.destinationPractice.addresses && $scope.destinationPractice.addresses.length == 1) {
                    $scope.model.referral.address_id = $scope.destinationPractice.addresses[0].id;
                }
                if (selectedItem.isInvitation) {
                    if (!restoredReferral) {
                        $scope.model.referral.dest_provider_invited_id = selectedItem.users[0].id;
                        $scope.model.referral.dest_provider_id = null;
                    }
                } else {
                    // DCL-431: the destination is fixed by the referral link's
                    // public id, so this uses the public_id-keyed endpoint rather
                    // than the authenticated one that took any internal practice_id.
                    $scope.destinationPractice.users = Practice.getPublicProviders({publicId: $stateParams.pid}, function(users){
                        if (!restoredReferral) {
                            $scope.model.referral.dest_provider_invited_id = null;
                            if (users.length == 1) {
                                $scope.model.referral.dest_provider_id = users[0].id;
                            }
                        }
                        users.unshift({id: -1, first_name: 'First', last_name: 'Available', firstAvailable: true});

                    });
                }
                ReferralHelper.selectPracticeType($scope, pickPracticeType);
            };

            // The form's procedure, e.g. a restored draft's, fixes the type (DCL-682):
            // the practice's own type would hide that procedure from the list. It is
            // read from the form rather than restoredReferral, which a destination
            // mismatch clears. The practice's type is the fallback when there is no
            // procedure or no listed type offers it.
            function pickPracticeType(practiceTypes) {
                var procedureId = $scope.model.referral.procedure_id;
                return ReferralHelper.practiceTypeIdOfProcedure(practiceTypes, procedureId) ||
                    ($scope.destinationPractice && $scope.destinationPractice.practice_type_id);
            }

            if(typeof $stateParams.pid !== 'undefined') {
                Practice.getByPublicId({publicId: $stateParams.pid}, function(practice) {
                    $scope.onPracticeSelected(practice);
                }, function (failure) {
                    Notification.error(failure.data.message);
                });
            }

            // ---- guest live-draft autosave (DCL-369) ----
            // The guest user (and their practice) must exist before a draft can be
            // anchored, so the lazy chain is: identity fields ready -> createGuest
            // -> createGuestReferral (returns the draft edit token) -> autosaves.

            function guestReady() {
                return !!($scope.guest && $scope.guest.first_name && $scope.guest.last_name && $scope.guest.email);
            }

            // DCL-649: a guest email the verifier rejects fails createGuest with
            // 422 {error: 'bad.email.address', suggestion?}. That rejection ends
            // up in the autosave's generic 'failed' state, so it is kept here to
            // tell the user what is actually wrong with the address.
            var badEmail = null;

            function badEmailRejection(failure) {
                var data = failure && failure.data;
                return BadEmailNotice.isRejection(data) ? data : null;
            }

            function ensureGuestUser() {
                if ($scope.guest && $scope.guest.id) { return $q.resolve($scope.guest); }
                return User.createGuest({guest_user: $scope.guest, dest_practice_public_id: $stateParams.pid}).$promise
                    .then(function (created) {
                        badEmail = null;
                        $scope.guest = created;
                        return created;
                    }, function (failure) {
                        badEmail = badEmailRejection(failure);
                        return $q.reject(failure);
                    });
            }

            var autosave = ReferralAutosave.createSession({
                buildPayload: function () { return ReferralHelper.buildGuestDraftPayload($scope); },
                canCreateDraft: guestReady,
                guestToken: function () { return guestToken; },
                createDraft: function () {
                    return ensureGuestUser().then(function () {
                        // rebuild: the payload passed in predates the guest user.
                        // No notes: the autosave PUT saves them (DCL-636).
                        return Referral.createGuestReferral(
                            ReferralAutosave.withoutNotes(ReferralHelper.buildGuestDraftPayload($scope))).$promise;
                    }).then(function (created) {
                        guestToken = created.draft_edit_token;
                        $scope.model.referral.id = created.id;
                        persistGuestDraft(created.id); // survive a reload (DCL-440)
                        return created;
                    });
                },
                onDraftCreated: function (referralId) {
                    // files added before the guest identity existed are still queued
                    ReferralHelper.uploadQueuedAttachments($scope, referralId);
                },
                onState: function (state) {
                    $scope.autosaveState = state;
                    if (state === 'failed' && badEmail) {
                        BadEmailNotice.notify(badEmail);
                    } else if (state === 'failed') {
                        Notification.error('Changes could not be saved. Please check your connection and try again.');
                    }
                },
                onSaved: function (data, sentPayload) { ReferralHelper.syncSavedNotes($scope, data, sentPayload); }
            });
            ReferralHelper.wireAutosave($scope, autosave, function (scope) {
                return ReferralHelper.buildGuestDraftPayload(scope);
            });

            // The notes block disables its new-note and edit controls while a
            // save request is open, so nothing races the list it answers with (DCL-636).
            $scope.notesBusy = function () { return autosave.isRequestInFlight(); };

            // Completing the identity fields doesn't change the draft payload, so the
            // generic watcher can't see it — flush pending local changes explicitly.
            $scope.$watch(guestReady, function (ready) {
                if (ready) { autosave.flush(); }
            });

            $scope.ensureDraftForUpload = function () { return autosave.ensureDraftNow(); };
            $scope.draftUploadHeaders = function () {
                return guestToken ? {'X-Draft-Edit-Token': guestToken} : {};
            };

            // Reload persistence (DCL-440): if a draft was persisted for this pid,
            // re-hydrate it from the server. On any failure (token invalid, draft
            // already sent/swept) drop the record and continue with a pristine form.
            (function restoreGuestDraft() {
                var raw = $window.sessionStorage.getItem(draftKey);
                if (!raw) { return; }
                var record;
                try { record = angular.fromJson(raw); } catch (e) { record = null; }
                // No email: a record from before DCL-642. The guest would retype it,
                // but the restored guest.id would make ensureGuestUser() ignore it.
                if (!record || !record.id || !record.token || !record.email) { forgetGuestDraft(); return; }

                $http.get(API_ENDPOINT + '/referrals/' + record.id + '/guest_draft',
                          {headers: {'X-Draft-Edit-Token': record.token}})
                    .then(function (response) {
                        var data = response.data;
                        data.notes = data.notes || [];
                        data.notes_attributes = [];
                        // orig_provider carries the guest identity: setting it fills the
                        // first/last inputs (the email comes from the stored record), makes
                        // guestReady() true and lets ensureGuestUser() short-circuit via
                        // guest.id (no duplicate guest).
                        $scope.guest = angular.extend({email: record.email}, data.orig_provider);
                        $scope.patient = data.patient || {};
                        // uib-datepicker-popup needs a Date in the model; the API returns
                        // 'yyyy-mm-dd'. Parse as local time so the day doesn't shift.
                        if ($scope.patient.birthday) {
                            var parts = String($scope.patient.birthday).split('-');
                            $scope.patient.birthday = new Date(parts[0], parts[1] - 1, parts[2]);
                        }
                        $scope.model.referral = data;
                        $scope.teeth = (data.teeth || '').split('+').filter(function (tooth) { return tooth; });
                        $scope.attachments = data.attachments || [];
                        guestToken = record.token;
                        restoredReferral = data; // guard onPracticeSelected's auto-pick
                        // The type select and the procedure list both read practiceType,
                        // which the draft doesn't hold (DCL-682).
                        ReferralHelper.selectPracticeType($scope, pickPracticeType);
                        autosave.adoptDraft(data.id);
                    }, function () {
                        forgetGuestDraft();
                    });
            })();

            $scope.sendReferral = function () {
                $scope.form.$setDirty();

                if ($scope.form.$invalid) {
                    return false;
                }
                if ($scope.uploader && ($scope.uploader.isUploading || $scope.uploader.queue.length > 0)) {
                    Notification.error('Please wait for attachments to finish uploading.');
                    return false;
                }

                autosave.flush().then(function () {
                    var id = autosave.referralId();
                    if (!id) {
                        Notification.error('Please fill in the referral before sending.');
                        return;
                    }
                    return $http.put(API_ENDPOINT + '/referrals/' + id + '/send', {},
                                     {headers: {'X-Draft-Edit-Token': guestToken}})
                        .then(function () {
                            forgetGuestDraft(); // draft is sent — no longer resumable (DCL-440)
                            UnsavedChanges.resetCbHaveUnsavedChanges();
                            var modalInstance = $uibModal.open({
                                templateUrl: 'partials/success_guest_referral_modal.html',
                                controller: 'SuccessGuestReferralModalController'
                            });
                            ModalHandler.set(modalInstance);
                            modalInstance.result.finally(function () {
                                $state.go('signIn');
                            });
                        });
                }).catch(function (failure) {
                    var rejectedEmail = badEmailRejection(failure);
                    if (rejectedEmail) {
                        BadEmailNotice.notify(rejectedEmail);
                        return;
                    }
                    var message = failure && failure.data && failure.data.message;
                    Notification.error(message || 'An error occurred during referral creation...');
                });
            };

            $scope.openPatientDatePicker = function($event) {
                $scope.datepickerStatus.opened = true;
            };

        }]);
